import DefineCustomPeerGroups from "../components/PeerGroup/DefineCustomPeerGroups";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { All } from "../interfaces";
import { initialAppState } from "../common/reducers/appState";

function mapStateToProps({ appState }: All) {
  return {
    appState: appState.peerGroup,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    resetState: () => {
      dispatch(actions.resetState(initialAppState.peerGroup));
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DefineCustomPeerGroups);
